import angular from 'angular';
import bySearchModule from './by-search/by-search';
import byFavoritesModule from './by-favorites/by-favorites';
import byLastItemsModule from './by-last-items/by-last-items';

let fastPurchaseModule = angular.module('app.fastPurchase', [
    bySearchModule.name,
    byFavoritesModule.name,
    byLastItemsModule.name
]);

export default fastPurchaseModule;



// WEBPACK FOOTER //
// ./www/components/fast-purchase/fast-purchase.js